import axios from 'axios';

const oilApi = axios.create({
  baseURL: process.env.VUE_APP_OIL_API_URL,
});
export default oilApi;
